<template>
    <div class="app-container">
    <el-row class="web">
      <el-row class="logo">
        <img style="width:500px;" src="../../assets/logoBG.png" alt="">
      </el-row>
      <el-row class="title">
        欢迎使用易思普综合管理平台
      </el-row>
      <el-dialog title="修改密码" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false" :visible.sync="dialogVisible" width="30%">
        <!-- <h3 class="dialogtitle">当前密码为初始密码请您修改密码</h3> -->
        
        <el-form :model="formparam" :rules="rules" ref="formparam" label-width="80px">
          <el-form-item label="密码" prop="password">
            <el-input class="w220" v-model="formparam.password" placeholder="请输入6-10位字母数字结合的密码"></el-input>
          </el-form-item>
          <el-col style="marginTop:50px;marginLeft:30px">*当前密码为初始密码，为了账户安全请输入密码</el-col>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button style="width:100px" @click="resetForm('formparam')">取 消</el-button> -->
          <el-button style="width:100px" type="primary" @click="submitSetInfo('formparam')">确 定</el-button>
        </span>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { updatePassword,getShops } from "../../api/configApi";
export default {
  data() {
    return {
      state:'',
      role:'',
      dialogVisible:false,
      rules: {
        password: [
          {
            required: true,
            min: 6,
            max: 10,
            message: "请输入6-10位字母数字结合的密码",
          }, 
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/,
            message: "请输入6-10位字母数字结合的密码",
            trigger: 'change'
          }
        ]
      },
      password:'',
      formparam: {
        password: ""
      },
    }
  },
  components: {
  },
  mounted() {
    this.state = JSON.parse(sessionStorage.getItem('userinfo')).state
    this.role = JSON.parse(sessionStorage.getItem('userinfo')).role
    if(this.state == 0){
      this.dialogVisible = true
    }
    if(this.role!='root'){
      this.getShopsList()
    }
  },
  methods: {
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        sessionStorage.setItem("shopList", JSON.stringify(res.data))
      })
    },
    submitSetInfo(formparam) {
      this.password = this.formparam.password
      var eles = [];
      eles.push(this.password);
      // var esz = this.encode("0x12",eles);
      this.password = this.common.encode("0x12",eles)  
      this.$refs[formparam].validate(valid => {
        if (valid) {
          updatePassword({password:this.password}).then(res => {
            if (res.msg == "success") {
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "修改成功，请重新登录"
              });
              this.dialogVisible = false;
              setTimeout(()=>{
                this.$router.push({path:'/login'})
              },2000)
            } else {
              this.$message({
                type: "error",
                message: res.data
              });
            }
          });
        } else {
          this.$message.error("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.logo{
  text-align: center;
  img{
    margin: 0 auto;
    margin-top: 260px;
  }
}
.dialogtitle{
  text-align: center
}
.title{
  font-size: 40px;
  text-align: center;
  color: #ccc;
  // line-height: 100px; 
}
</style>


// WEBPACK FOOTER //
// commonHome.vue?2ebe8983